import { CheckBadgeIcon, Cog6ToothIcon, MapPinIcon, Square3Stack3DIcon, Squares2X2Icon, UserIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';
import { SidebarNavItem } from 'softcat:components/sidebar-nav-item.tsx';
import { SidebarNavSubmenu } from 'softcat:components/sidebar-nav-submenu.tsx';
import { UserRole } from 'softcat:config/user-role.ts';
import { useAuth } from 'softcat:hooks/use-auth.ts';

export const SidebarNav = () => {
    const { hasRequiredRole } = useAuth();

    return (
        <nav className="flex flex-1 flex-col" data-testid={'sidebar-nav'}>
            <ul className="-mx-2 space-y-1">
                {hasRequiredRole(UserRole.USER) && (
                    <SidebarNavItem to="../apps">
                        <Squares2X2Icon height={18} strokeWidth={2} width={18} />
                        <FormattedMessage id="SIDEBAR_NAV_APPS" />
                    </SidebarNavItem>
                )}

                {hasRequiredRole(UserRole.ADMIN) && (
                    <SidebarNavItem to="../locations">
                        <MapPinIcon height={18} strokeWidth={2} width={18} />
                        <FormattedMessage id="SIDEBAR_NAV_LOCATIONS" />
                    </SidebarNavItem>
                )}

                {hasRequiredRole(UserRole.USER) && (
                    <SidebarNavItem to="../catalogues">
                        <Square3Stack3DIcon height={18} strokeWidth={2} width={18} />
                        <FormattedMessage id="SIDEBAR_NAV_CATALOGUES" />
                    </SidebarNavItem>
                )}

                {hasRequiredRole(UserRole.SUPERADMIN) && (
                    <SidebarNavItem to="../certificates">
                        <CheckBadgeIcon height={18} strokeWidth={2} width={18} />
                        <FormattedMessage id="SIDEBAR_NAV_CERTIFICATES" />
                    </SidebarNavItem>
                )}

                {hasRequiredRole(UserRole.SUPERADMIN) && (
                    <SidebarNavItem to="../users">
                        <UserIcon height={18} strokeWidth={2} width={18} />
                        <FormattedMessage id="SIDEBAR_NAV_USERS" />
                    </SidebarNavItem>
                )}

                {hasRequiredRole(UserRole.SUPERADMIN) && (
                    <SidebarNavSubmenu icon={<Cog6ToothIcon height={18} strokeWidth={2} width={18} />} title={<FormattedMessage id="SIDEBAR_NAV_CONFIG" />}>
                        <ul>
                            <SidebarNavItem to="../config/entitlements">
                                <span className="pl-8">
                                    <FormattedMessage id="SIDEBAR_NAV_CONFIG_ENTITLEMENTS" />
                                </span>
                            </SidebarNavItem>
                            <SidebarNavItem to="../config/platforms">
                                <span className="pl-8">
                                    <FormattedMessage id="SIDEBAR_NAV_CONFIG_PLATFORMS" />
                                </span>
                            </SidebarNavItem>
                            <SidebarNavItem to="../config/config-versions">
                                <span className="pl-8">
                                    <FormattedMessage id="SIDEBAR_NAV_CONFIG_CONFIG_VERSIONS" />
                                </span>
                            </SidebarNavItem>
                        </ul>
                    </SidebarNavSubmenu>
                )}
            </ul>
        </nav>
    );
};
